module.exports = __webpack_public_path__ + "static/media/profile.bd9de846.png";